import { render } from "./Countdown.vue?vue&type=template&id=17a43710"
import script from "./Countdown.vue?vue&type=script&lang=js"
export * from "./Countdown.vue?vue&type=script&lang=js"
script.render = render

export default script